import { render, staticRenderFns } from "./AssignRoleDialog.vue?vue&type=template&id=236eaafa&scoped=true"
import script from "./AssignRoleDialog.vue?vue&type=script&lang=js"
export * from "./AssignRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignRoleDialog.vue?vue&type=style&index=0&id=236eaafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236eaafa",
  null
  
)

export default component.exports